const SUPER_ADMIN_ROLE = 'ROLE_ADMIN';

const checkIntersection = (role:string, target:string[]):boolean => {
    if (Array.isArray(role)) {
        return Boolean(target.filter(el => role.indexOf(el) >= 0).length);
    }
    else {
        return Boolean(target.indexOf(role.trim()) >= 0);
    }
};

const hasAccess = (role: string, roles: string[]):boolean => {
    const currentRole = role ? role : '';
    const rolesList = roles ? roles : [];
    if (rolesList.indexOf(SUPER_ADMIN_ROLE) >= 0) {
        return true;
    }
    if (!rolesList) {
        return false
    }
    return Boolean(rolesList && Array.isArray(rolesList) && checkIntersection(currentRole, rolesList));
};

export { checkIntersection, hasAccess, SUPER_ADMIN_ROLE };